import {MediaBaseURL} from "@/utils/settingz"


const getters = {
    username: state => state.user.UserInfo.username,
    token: state => state.user.token,
    avatar: state => MediaBaseURL+state.user.UserInfo.avatar,
    rule_list: state => state.user.UserInfo.url_list

}

export default getters;